import React from "react";
import styled from "styled-components";
import { graphql } from "gatsby";

const StyledWrapper = styled.div`
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  padding: 1rem 0rem;
  display: flex;
  justify-content: center;
`;

const StyledDivider = styled.div`
  width: 50%;
  height: 1px;
  opacity: 0.8;
  background-color: ${(props) => props.theme.color[props.color]};
`;

export default function DividerModal({ color, backgroundColor }) {
  return (
    <StyledWrapper backgroundColor={backgroundColor && backgroundColor.color}>
      <StyledDivider color={color.color} />
    </StyledWrapper>
  );
}

export const query = graphql`
  fragment dividerModal on STRAPI_ComponentBaseDivider {
    __typename
    id
    color {
      color
    }
    backgroundColor {
      color
    }
  }
`;
